module.exports = __webpack_public_path__ + "img/dashboard-default.ead50881.svg";